import { PropsWithChildren } from 'react';

import { Collapse } from '@mui/material';

interface FiltersContainerProps {
  expanded: boolean;
}

function FiltersContainer(props: PropsWithChildren<FiltersContainerProps>) {
  const { children, expanded } = props;
  return <Collapse in={expanded}>{children}</Collapse>;
}
export default FiltersContainer;
